export default __webpack_public_path__ + "static/media/coinbase.c1beaef8.png";